import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import "./IssueReturn.css"

export const IssueReturn = () => {
  return (
        <>
        <RoutingMenu activeScreen="issueReturnResource" />
    <div className=''>

        <iframe

            src={`${config.RootUrl}/faculty/library/issueResource/issueResourceHTML.php?isIframe=true`}
            className="iframe col-md-12"
        >
        </iframe>
    </div>
    </>
  )
}
